import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Container from "../components/misc/Container";
import LayoutHomepage from "../layout/LayoutHomepage";
import DynamicScrollToTop from '../components/misc/DynamicScrollToTop';


const Terms = () => {
  return (
    <>
    <DynamicScrollToTop/>
      <LayoutHomepage>
        <div className="flex flex-col w-full mt-32">
          <Container>
            <div className="flex flex-col w-full mr-2 mb-6">
              <div className="flex w-full mt-8 mb-8">
                <Link to="/homepage">
                <p className="flex items-center text-font-gray opacity-50">
                  Beranda{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-3 h-3 opacity-100 mx-2"
                    viewBox="0 0 11.384 20.025"
                  >
                    <g
                      id="Group_4034"
                      data-name="Group 4034"
                      transform="translate(1.414 1.414)"
                    >
                      <line
                        id="Line_452"
                        data-name="Line 452"
                        x2="12.099"
                        transform="translate(8.555 8.642) rotate(135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                      <line
                        id="Line_453"
                        data-name="Line 453"
                        x2="12.099"
                        transform="translate(8.555 8.555) rotate(-135)"
                        fill="none"
                        stroke="#596375"
                        strokeLinecap="round"
                        strokeWidth="2"
                      />
                    </g>
                  </svg>
                </p>
                </Link>
                <h1 className="text-font-gray">Syarat dan Ketentuan</h1>
              </div>
              <div className="py-4 rounded bg-white">
                <div className="flex px-1  border-gray-300">
                  <div className="flex items-center p-4">
                    <h4 className="text-3xl font-semibold text-font-gray mb-2">
                      Syarat & Ketentuan
                    </h4>
                  </div>
                </div>
                {/* Section Agreement */}
                <div className="flex px-1 border-gray-300 pb-2">
                  <div className="flex items-center p-4">
                    <p className="font-medium">
                      Mohon untuk membaca syarat dan ketentuan (“Syarat dan
                      Ketentuan”) yang tertulis di bawah ini secara seksama
                      sebelum memesan Barang atau menggunakan Layanan dari Situs
                      ini. Untuk menggunakan Layanan kami, Anda harus berumur 21
                      tahun atau lebih. Apabila Anda berumur di bawah 21 tahun,
                      maka anda membutuhkan izin dari orang tua atau wali anda.
                      Dengan tetap mengakses Situs ini dan memesan Barang atau
                      Layanan dari Situs ini melalui telepon atau aplikasi
                      telepon genggam kami, Anda setuju untuk terikat dengan
                      Syarat dan Ketentuan ini. SENTRA BLANJA sebagai penyedia
                      Platform mempunyai usaha di bidang pengembangan,
                      pengoperasian, pengaturan sebuah online marketplace yang
                      menyediakan daftar produk pada agrotech.id sebuah domain
                      internet yang didaftarkan atas nama AGROTECH dan/atau
                      Aplikasi iOS dan Android. OLEH KARENA ITU PARA PIHAK
                      SEPAKAT ATAS KETENTUAN DI BAWAH INI:
                    </p>
                  </div>
                </div>
                {/* End of section agreement */}
                <h3 className="ml-6 text-3xl font-semibold">1 . Pendahuluan</h3>
                <div className="flex px-1 border-gray-300 pb-2">
                  <div className="flex items-center p-4">
                    <p className="font-medium">
                      Sentra belanja mengumpulkan data Pengguna dengan tujuan
                      untuk memproses transaksi Pengguna, mengelola dan
                      memperlancar proses penggunaan Situs, serta tujuan-tujuan
                      lainnya selama diizinkan oleh peraturan perundang-undangan
                      yang berlaku. Adapun data Pengguna yang dikumpulkan adalah
                      sebagai berikut:
                    </p>
                  </div>
                </div>

                <div className="flex px-1 border-gray-300 pb-2">
                  <div className="flex items-center p-4">
                    <p className="font-medium">
                      A. Data yang diserahkan secara mandiri oleh Pengguna,
                      termasuk namun tidak terbatas pada data yang diserahkan
                      pada saat Pengguna:
                      <ul>
                        <li>
                          {" "}
                          1. Membuat atau memperbarui akun Sentra Blanja,
                          termasuk diantaranya nama pengguna (username), alamat
                          email, nomor telepon, password, alamat, foto, dan
                          lain-lain; 2. Menghubungi Sentra Blanja, termasuk
                          melalui layanan konsumen; 3. Mengisi survei yang
                          dikirimkan oleh Sentra Blanja atau atas nama Sentra
                          Blanja; 4. Melakukan interaksi dengan Pengguna lainnya
                          melalui fitur pesan, diskusi produk, ulasan, rating,
                          Pusat Resolusi dan sebagainya; 5. Mempergunakan
                          layanan-layanan pada Situs, termasuk data transaksi
                          yang detil, diantaranya jenis, jumlah dan/atau
                          keterangan dari produk atau layanan yang dibeli,
                          alamat pengiriman, kanal pembayaran yang digunakan,
                          jumlah transaksi, tanggal dan waktu transaksi, serta
                          detil transaksi lainnya; 6. Mengisi data-data
                          pembayaran pada saat Pengguna melakukan aktivitas
                          transaksi pembayaran melalui Situs, termasuk namun
                          tidak terbatas pada data rekening bank, kartu kredit,
                          virtual account, instant payment, internet banking,
                          gerai ritel; dan/atau 7. Menggunakan fitur yang
                          membutuhkan izin akses terhadap perangkat Pengguna.
                        </li>
                      </ul>
                    </p>
                  </div>
                </div>

                <div className="flex px-1 border-gray-300 pb-2">
                  <div className="flex items-center p-4">
                    <p className="font-medium">
                      B. Data yang terekam pada saat Pengguna mempergunakan
                      Situs, termasuk namun tidak terbatas pada: 1. Data lokasi
                      riil atau perkiraannya seperti alamat IP, lokasi Wi-Fi,
                      geo-location, dan sebagainya; 2. Data berupa waktu dari
                      setiap aktivitas Pengguna, termasuk aktivitas pendaftaran,
                      login, transaksi, dan lain sebagainya; 3. Data penggunaan
                      atau preferensi Pengguna, diantaranya interaksi Pengguna
                      dalam menggunakan Situs, pilihan yang disimpan, serta
                      pengaturan yang dipilih. Data tersebut diperoleh
                      menggunakan cookies, pixel tags, dan teknologi serupa yang
                      menciptakan dan mempertahankan pengenal unik; 4. Data
                      perangkat, diantaranya jenis perangkat yang digunakan
                      untuk mengakses Situs, termasuk model perangkat keras,
                      sistem operasi dan versinya, perangkat lunak, nomor IMEI,
                      nama file dan versinya, pilihan bahasa, pengenal perangkat
                      unik, pengenal iklan, nomor seri, informasi gerakan
                      perangkat, dan/atau informasi jaringan seluler; 5. Data
                      catatan (log), diantaranya catatan pada server yang
                      menerima data seperti alamat IP perangkat, tanggal dan
                      waktu akses, fitur aplikasi atau laman yang dilihat,
                      proses kerja aplikasi dan aktivitas sistem lainnya, jenis
                      peramban, dan/atau situs atau layanan pihak ketiga yang
                      Anda gunakan sebelum berinteraksi dengan Situs.
                    </p>
                  </div>
                </div>

                <div className="flex px-1 border-gray-300 pb-2">
                  <div className="flex items-center p-4">
                    <p className="font-medium">
                      C. Data yang diperoleh dari sumber lain, termasuk: 1.
                      Mitra usaha Sentra Blanja yang turut membantu Sentra
                      Blanja dalam mengembangkan dan menyajikan layanan-layanan
                      dalam Situs kepada Pengguna, antara lain mitra penyedia
                      layanan pembayaran, logistik atau kurir, infrastruktur
                      situs, dan mitra-mitra lainnya. 2. Mitra usaha Sentra
                      Blanja tempat Pengguna membuat atau mengakses akun Sentra
                      Blanja, seperti layanan media sosial, atau situs/ aplikasi
                      yang menggunakan API Tokopedia atau yang digunakan Sentra
                      Blanja; 3. Penyedia layanan finansial, termasuk namun
                      tidak terbatas pada lembaga atau biru pemeringkat kredit
                      atau Lembaga Pengelola Informasi Perkreditan (LPIP); 4.
                      Penyedia layanan finansial (apabila Pengguna menggunakan
                      fitur spesifik seperti Mitra Toppers); 5. Penyedia layanan
                      pemasaran; 6. Sumber yang tersedia secara umum. Sentra
                      Blanja dapat menggabungkan data yang diperoleh dari sumber
                      tersebut dengan data lain yang dimilikinya.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </LayoutHomepage>
    </>
  );
};

export default Terms;
